import * as min from "lodash/min";
import * as delay from "lodash/delay";
import * as intersection from "lodash/intersection";
import * as sortBy from "lodash/sortBy";

import {parseUrl} from "../../waters_filter_utils";
import {updateUrl} from "../../waters_filter_utils";
import {searchToObject} from "../../filter_utils";

const $ = require('jquery');
require('jquery.cookie');
export default class WatersFilterMain extends React.Component {
  constructor(props) {
    super(props);
    this.pageSize = this.props.filter_params.page_size;
    let obj = {};
    const search_obj = searchToObject(window.location.search);
    this.isFiltered = false;

    if ((intersection(Object.keys(search_obj), this.filterNames()).length > 0)) {
      obj = parseUrl();
    }

    this.init_filter_params = obj;
    const waters = this.props.waters ?? [];
    const seo_page = this.props.seo_page;

    const types = seo_page?.filter_params?.river_type
      ? [parseInt(seo_page.filter_params.river_type)]
      : obj.types?.map((n) => parseInt(n));

    this.state = {
      waters: waters,
      pageNum: (obj.page - 1) || 0,
      filters: {
        types: types || []
      }
    };

    this.bindFunctions = this.bindFunctions.bind(this);
    this.bindFunctions();
  }

  filterNames() {
    return [
      'types',
      'page'
    ]
  }

  componentDidMount() {
    this.filter(this.state.filters, false, false);
  }

  getPage() {
    const waters = this.state.waters;
    const start = this.state.pageNum * this.pageSize;
    const end = min([start + this.pageSize, waters.length]);
    return waters.slice(start, end);
  }

  setPageNum(i) {
    $('html, body').animate({scrollTop: 250}, 300);
    delay(() => {
      this.setState({
        pageNum: i
      }, () => { updateUrl(this.state.filters, this.state.pageNum) });
    }, 100);
  }

  resetPageNum() {
    this.setState( {
      pageNum: 0
    });
  }

  resetFilter() {
    const initialFilters = {
      types: []
    };

    this.setState({
      filters: initialFilters,
      pageNum: 0
    }, () => {
      this.filter(this.state.filters, true, true)
    });
  }

  totalPages() {
    return Math.ceil(this.state.waters.length / this.pageSize);
  }

  sortByActive() {
    let arr = this.state.waters;
    const activeWaters = sortBy(arr.filter(water => water.active_post_page_status === true));
    const inactiveWaters = sortBy(arr.filter(water => water.active_post_page_status !== true));

    return this.setState({
      waters: [...activeWaters, ...inactiveWaters]
    });
  }

  sortByPopular() {
    let sorted = sortBy(this.state.waters, water => (water.is_popular === true) ? -1 : 1)
    this.setState({
      waters: sorted
    });
    this.isFiltered = true;
  }

  filter(filters, doUpdateUrl = true, resetPageNum = true, callback) {
    const {waters} = this.props;
    let filteredWaters = waters.filter(water => {
      return (
        (filters.types.length === 0 || filters.types.includes(water.river_type))
      );
    });

    this.setState({
      waters: filteredWaters
    }, () => {
      this.sortByActive();
      this.sortByPopular();
      if (callback) callback();
      if (doUpdateUrl) {
        updateUrl(this.state.filters, this.state.pageNum, resetPageNum)
      }
    });
  }

  bindFunctions () {
    this.filterNames = this.filterNames.bind(this);
    this.getPage = this.getPage.bind(this);
    this.setPageNum = this.setPageNum.bind(this);
    this.resetPageNum = this.resetPageNum.bind(this);
    this.totalPages = this.totalPages.bind(this);
    this.sortByActive = this.sortByActive.bind(this);
    this.sortByPopular = this.sortByPopular.bind(this);
    this.filter = this.filter.bind(this);
    this.resetFilter = this.resetFilter.bind(this);
  }
}
